import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import "./Founder.css";

const Founder = () => {
  const [imageRef, imageVisible] = useScrollAnimation();
  const [contentRef, contentVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="founder">
      <div className="founder-container">
        <div ref={imageRef} className={`founder-image-container ${imageVisible ? "animate-in" : ""}`}>
          <img
            src="/founder.png"
            alt="Dr. Paige Afanu"
            className="founder-image"
          />
        </div>
        <div ref={contentRef} className={`founder-content ${contentVisible ? "animate-in" : ""}`}>
          <h2 className="founder-title">Founder & Adviser: Dr. Paige Afanu</h2>
          <p className="founder-description">
            Dr. Paige Afanu is a Licensed Financial Advisor and Insurance Agent in Ontario. Her approach is professional, collaborative, and focused on helping clients make confident, well-informed decisions without pressure.
          </p>
          <p className="founder-description">
            Specializing in the unique needs of professionals, business owners, and homeowners, Paige utilizes a data-driven framework to support:
          </p>
          <ul className="founder-services">
            <li>Mortgage & Debt Protection Reviews: Finding savings during renewal or refinancing.</li>
            <li>Income & Overhead Protection: Structured disability and critical illness planning for incorporated professionals.</li>
            <li>Long-Term Protection Planning: Aligning insurance-based strategies with retirement and estate goals.</li>
            <li>Insurance Needs: Disability, health, dental and critical illness insurance planning.</li>
          </ul>
          <p className="founder-description">
            Her approach is professional, collaborative, and focused on helping clients make confident, well-informed decisions—without pressure.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Founder;
